<ngx-loading-bar [color]="'#7366ff'" [height]="'4px'" [includeSpinner]="false"></ngx-loading-bar>
<app-loader></app-loader>
<app-tap-to-top></app-tap-to-top>
<router-outlet></router-outlet>
